<!-- <button class="close-button" (click)="declineTermAndCondition()">
  <span aria-hidden="true">&times;</span>
</button>
<div mat-dialog-title> -->
  <!-- <div class="poptitle">
    <div class="register-logo">
      <img src="/images/new_ui/terms-logo.jpg" alt="register-logo">
    </div>
    <div class="company-info">
      DICKER DATA LTD<br> ABN: 95 000 969 362<br> 230 Captain Cook Drive<br> Kurnell NSW 2231<br>
    </div>
    <div class="company-contact">
      <a href="www.dickerdata.com.au">www.dickerdata.com.au</a> <br> Freecall: 1800 688 586<br> Freefax: 1800 688
      486<br>
      Phone:
      (02) 9589-8400<br> Fax: (02) 9525-0481<br>
    </div>
  </div> -->
  <!-- <div class="modal-header">
    <h6 class="modal-title">Terms & Conditions</h6>
  </div>
</div> -->
<child-header title="Terms & Conditions" (closeEvent)="declineTermAndCondition()"></child-header>
<div class="mat-dialog-body">
  <div mat-dialog-content> 
    <div class="terms-description">
      These are the terms and conditions on which DICKER DATA LTD (“we” or “us” or “our”) is willing to trade with you.
      Any variation to these terms and conditions must be in writing and signed by an authorised officer of DICKER DATA
      LTD.
      You agree that these terms and conditions create a PMSI in the product (and its proceeds) supplied presently and in
      the future by us to you.

      <ul style="list-style-type: decimal;">
        <li>
          <b> Scope, Product &amp; Price</b>
          <ul style="list-style-type: lower-alpha;">
            <li>
              These terms and conditions includes the provisions relating to your use of our product (as defined below).
              We have alliance relationships with Third-Party Suppliers. As part of many such arrangements we are able to
              resell the Third-Party Products and may receive discounts or rebates in connection from the Third-Party
              Suppliers with the sale of such Third-Party Products. These terms and conditions are in addition to any
              terms and conditions that apply to a Third-Party Product which may be provided to you or made otherwise
              available on the applicable Third-Party Supplier’s website. Third-Party Suppliers are independent
              contractors and are not employees, agents, subcontractors or authorized representatives, partners or joint
              ventures of us. You will ensure your agreement with customers contains terms no less favourable than those
              outlined in these terms and conditions and specifically includes those terms set out in Schedule 2 (Specific
              Customer Terms).
            </li>
            <li>
              You may offer to purchase from us certain products, being: (i) our products, which may include the provision
              of equipment or a cloud environment (“ <b> our product</b>”); and (ii) products or services
              (including data migration services and provision of a cloud environment) provided by Third Party Suppliers
              ("collectively, "<b> the products </b>").
            </li>
            <li>
              The price and description of the products you may offer to purchase from us is described in our price list.
              We may change the products and price list at any time without prior notice. We reserve the right to replace
              any of the products with products that are substantially similar if for any reason the products become
              unavailable. Any description of our product including any specifications, illustrations, drawings, data,
              dimensions and weights is approximate and is given by way of identification only. The use of that
              description does not constitute a sale by description and does not form part of our contract with you unless
              we say so in writing. You are responsible for ensuring that the products ordered is suitable for its
              intended use by you and we are not liable to you for any product you order which is unsuitable for your
              intended use. All pricing of the products will be in accordance with our price list and we reserve the right
              to invoice you in accordance with that price list despite any such unintended errors on our website or data
              entry errors.
            </li>
            <li>
              If we provide you with a quotation, it is valid only for the period specified in the quotation or 30 days,
              whichever is the lesser, and only in respect of the matters set out in the quotation.
            </li>
          </ul>
        </li>
        <li>
          <b> Subscription, consumption and multi-year contract billing</b> <br>The products defined in
          Clause 1(a) and 1(b) may include products and services (including Cloud services) that utilize various billing
          methods including subscription, consumption and multi-year contract billings, including but not limited to:
          <ul style="list-style-type: lower-alpha;">
            <li>
              Subscription billing for products and services delivered over an agreed period (including multiple years),
              with invoicing spread across one or more periods within the delivery period.
            </li>
            <li>
              Consumption billing for services delivered over an agreed period (including multiple years), with invoicing
              based on usage levels of products and services within an agreed billing frequency.<br>If you
              purchase any subscription, consumption or multi-year contract product or service from us in accordance with
              clause 2, you agree that you:
              <ul style="list-style-type: lower-roman;">
                <li> i) must act in accordance with Clause 11 relating to Third-Party Products and Services.</li>
                <li>
                  must not misrepresent or misreport in any way, usage levels through either regular reporting or as the
                  result of an audit.
                  In the event that you breach any of these terms and conditions, and without limiting any other rights we
                  may have with respect to your default, you agree that:

                </li>
                <li>
                  we may, in our discretion, cease supplying the services to you, by either suspending your account or
                  terminating this supply agreement with you; and
                </li>
                <li>
                  if we cease supplying the services to you, you must assign to us all of your rights and obligations
                  under any End User Agreements you have entered into with End Users in accordance with your End-User
                  Agreements.
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          <b>Payment</b><br> If you have a pre-approved account limit with us, our terms are strictly in
          accordance with our payment terms as separately agreed with you in writing from time to time, or where there is
          no separate agreement, 10 days from the date of invoice. If you do not have a pre-approved account limit,
          payment in advance by cash, cheque, EFT, Bpay or credit card is required and must be paid within 48 hours of
          placing an order (failing which, we will be entitled to cancel the order without notice to you). Payments by
          cheque will not be considered received by us until the cheque is cleared by our bank. If any payment by you is
          dishonoured, you must pay us an additional account processing fee of $40.00.
          <br> These terms of payment also apply to any work we perform or service we provided to you on request
          which is separate from your purchase of product.<br> An account processing fee will be charged, unless
          otherwise agreed, for payments made by credit card, up to 2% for payments made by Visa, Mastercard or Moneytech
          card and 3% for payments made by American Express. <br> You agree to pay us not withstanding not having
          received payment by your end-users or customers. We may require either a deposit or funds held in escrow, to be
          applied against outstanding liabilities. This clause survives termination or expiry of these terms and
          conditions.
          <br>
        </li>
        <li>
          <b> Account Limit</b><br>Normally, we allow you to purchase and continue to purchase our
          product as long as the total of your account does not exceed your pre-approved account limit (if any) and you
          have provided us with three (3) satisfactory written trade references and/or a satisfactory trade or status
          report from a credit rating agency acceptable to us. We may require fresh references/reports from time to time
          and additional information if you apply to increase your account limit.
          <br> If we perform work or provide a service to you separate from your purchase of product, our fee for
          providing such work or service is added to your account. <br> You agree that you will, if we request,
          also provide us further supporting documentation which may include (but is not limited to) any or all of the
          following:<br>
          <ul>
            <li style="margin-bottom: 2px;"> evidence that you have been incorporated for at least 12 months; and</li>
            <li>a copy of your Financial Statements (which must not be more than 12 months old).</li>
          </ul>

          In no circumstances are we obliged to accept any application for an increase in the limit of your account and we
          are not
          obliged to give you reasons for our decision.<br> If any account is not settled within our trading
          terms, you
          agree that, in addition to any other right we may have, we may suspend all sales and delivery of our product to
          you
          or close your account with us. You acknowledge that we may decline your application to purchase our products if
          we
          are advised by our insurers that they will not grant us appropriate cover in relation to you.<br>
        </li>
        <li>
          <b> Overdue Accounts</b><br> You must pay for the product by each Due Date not withstanding
          not having received payment by your end-users or customers. Any account which is not settled by the Due Date
          will attract a late payment fee equal to 1% of your unpaid account, charged monthly until your account is paid
          in full. You agree that this late payment fee is a genuine pre-estimate of the loss we would suffer if you do
          not pay for the product by the Due Date. Notwithstanding your acknowledgement under clause 25, if the
          arrangements provided under this clause would otherwise constitute a credit contract as defined in the Consumer
          Credit Code the time for payment of any overdue account is limited to a total period not more than 62 days from
          the date of invoice. Nothing in this clause imposes an obligation on us to extend our payment terms to you for
          any period at all and we will not dispatch any products nor accept any further orders you place with us if your
          account is outstanding beyond 60 days from the date of invoice. You agree that any discounts, rebates or other
          concessions are lost if payment is not made in time. If you are in breach of any of our terms and conditions you
          agree that you are also responsible for all our expenses of any kind including our legal costs on a solicitor
          client basis and any commission or other expense incurred by any debt collection agency we retain to recover the
          monies you owe us. We may commence legal proceedings against you for the recovery of any account which is
          overdue by 60 days or more from the date of invoice.<br>
          In this clause,<b> “Due Date”</b> means the date specified in clause 3 on or by which you must pay your
          account
          with us.<br>
        </li>
        <li>
          <b> Taxes and Government Charges</b><br>Our prices are shown exclusive of all taxes,
          (including GST). Tax is payable in addition to the price of our product or service and must be paid by you at
          the same time as you pay for the products. We will give you a tax invoice compliant with the Law. You agree to
          reimburse and hold us harmless from any deficiency (including penalties and interest) relating to taxes that are
          your responsibility.<br>
        </li>
        <li>
          <b>Orders</b><br> All communications between you and us including all purchase orders must be
          in writing (which includes
          by e-mail). Verbal orders must be confirmed in writing within 24 hours and will be considered as accepted by us
          on
          delivery.
          <br> Unless we agree special arrangements, such as an authorisation code, we assume any order received
          from anyone
          in your employ has been placed with your authority and is binding on you.<br> No quote is binding on us
          unless we have
          prepared and accepted a written confirmation of order.<br>If you make a change to an order or your
          delivery details change which cause a delivery delay or you cancel an order less than 14 days prior to a
          scheduled delivery, you will pay to us a fee equal to 5% of the list price of any product affected. If you
          cancel an order for any product not included in our current price list, you may be subject to an additional
          charge. If you cancel an order or refuse to accept all or any of our product in an order other than in
          circumstances permitted by these terms and conditions, you will be liable for any resulting damage or loss
          suffered by us. If the product has been or is in the process of being manufactured or produced specifically for
          you, you will pay to us as liquidated damages the full price of the products and any costs incurred by us
          (including, without limitation, any tax, including GST) less the current scrap value of the product as
          determined by us.<br>
        </li>
        <li>
          <b> Delivery</b>
          <br>Delivery takes place on the earlier of the time our product passes into your or your agent’s
          exclusive physical control, when you collect the product or arrange for their collection from us or when
          ownership of our product has passed to you.
          <br> We will be entitled to cancel orders without notice if delivery of order cannot be taken within 48
          hours of placing the order, unless otherwise agreed by us. Our prices are shown exclusive of delivery costs.
          Delivery costs are payable in addition to the price of our product and must be paid by you at the same time as
          you pay for our product.
          <br>Unless we make other arrangements with you, our product is delivered direct to your business
          address described
          in your account. If you request that we deliver our product to another address, we may charge you an additional
          fee.
          <br>Any date for delivery of our product indicated by us is an estimated date for delivery only. We are
          under no liability for any loss or damage, however it arises, and you may not treat the relevant purchase order
          or these terms and conditions as terminated, if the product is not delivered by that date.
          <br>We reserve the right to deliver any products you order from us by instalment and each instalment is
          sold to you under a separate contract between you and us. Failure by us to deliver any instalment will not
          entitle you to cancel the balance of your order. In the event you are in default of these terms and conditions
          in respect of any instalment, we may elect to treat your default as a breach in respect of each other
          instalment.
          <br>We may charge you storage, handling and re-delivery fees if you are unable to take delivery of our
          product at the time we deliver our product to you.<br>
        </li>
        <li>
          <b>Risk</b><br>At all times from the date of delivery, our product is at your risk of loss or
          damage and you are responsible for its safe custody. You must keep our product insured and promptly provide us
          with evidence of such insurance and its currency as and when requested by us from time to time.<br>
        </li>
        <li>
          <b>Ownership</b><br>You do not own any of our product in your possession until all of our
          product you have purchased from us at any time and all other amounts owing by you to us on any account have been
          paid for in full. Until you have given us full payment, you promise to store and deal with our product in a way
          that it is clearly identifiable as ours. You grant us an irrevocable licence to enter your premises on any
          business day to inspect our product in your possession and your books or records regarding our product. If you
          wish, you may promote and on-sell our product in the ordinary course of business even if ownership of our
          product has not passed to you. If requested by Dicker Data, you will hold the proceeds of sale in trust and not
          by way of security, for and as agent for us in a separate account, you will pay the proceeds to us as soon as
          you receive them and we have the right to trace and claim such proceeds. You have no right to bind us to any
          liability to any third party by contract or otherwise. If you use our product in some manufacturing or
          construction process of your own or some third party, you will hold such part of the proceeds as relates to our
          product in trust for us. Such part shall be deemed to equal in dollar terms the amount payable or owing by you
          to us at the time of the receipt of such proceeds. You will also keep separate records and clearly identify in
          your books your use of our product in such manufacturing or construction process.<br>
        </li>
        <li>
          <b>Third Party Products and Services</b> <br>
          <ul style="list-style-type: lower-latin;">
            <li>
              You agree that the terms of use for any Third-Party Products shall exclusively be set out by the applicable
              Third-Party Supplier.
              While we may provide a facilitation role (and nothing more than that), you agree that we are not
              responsible, nor
              liable, for any Third-Party Products.
            </li>
            <li>
              Notwithstanding anything else, your licence to use any Third-Party Products is provided by the Third-Party
              Supplier and not us, and is subject to any terms and conditions as made available by the Third-Party
              Supplier, including, but not limited to, licenses, policies, warranties, ownership of intellectual property,
              privacy, scope of permitted use and other documentation.
            </li>
            <li>
              We make no representation or commitment, and shall have no liability or obligation whatsoever, in relation
              to the content
              or use of, or correspondence or contract you have with, any such Third-Party Products, or any transactions
              completed,
              and any contract entered into by you with such third party. You acknowledge that we are not an employee,
              franchisee,
              partner or joint venture of Third Party Suppliers.
            </li>
            <li>
              We do not endorse or approve any Third-Party Products. It is your sole responsibility to determine that
              specific products or services, introduced or used by you meets the needs of your business and/or are
              suitable for the purposes for which they are used.
            </li>
            <li>
              You acknowledge that Third Party Suppliers are entitled, as a Third-Party beneficiary of these terms and
              conditions, with the authority to independently enforce its provisions insofar as it relates to the
              Third-Party Products and / or impacts the Third-Party Supplier.
            </li>
          </ul>
        </li>
        <li>
          <b> Assignment</b> <br> You must not assign any rights or benefits under these terms and
          conditions unless you have
          obtained our prior written consent. We may assign our rights and benefits under these terms and conditions at
          any time
          without notice.
        </li>
        <li>
          <b>Recovery</b> <br> If at any time you owe us money on any account in excess of our trading
          terms then in addition
          to any other rights we have you agree we may enter any premises owned, possessed or controlled by you where our
          product
          is stored and remove our product and re-sell all or any of them. We are not liable to you if we take such
          action. If
          we request you will obtain a landlord’s waiver in a form acceptable to us.
        </li>
        <li>
          <b> Returns</b> <br> When you take delivery of our product, you must inspect it immediately.
          You must report to us
          in writing any damage, suspected defects or incorrect supply which must be received by us within 7 days of
          delivery
          otherwise we may refuse any claim you make. If our product is damaged when we deliver it to you we may accept
          its return
          and replace it with an equivalent product or credit you with the price paid, at our option. You must comply with
          any
          reporting requirements imposed by either us or a Third-Party Supplier. To return any product to us, you must
          obtain
          a Return Material Authorisation Number (RMA#) from us by contacting ras@dickerdata.com.au.

          <br> We will accept the return of our product if our product is not in accordance with your order, your
          proof of purchase
          is returned, and it is returned to us in its original condition within 14 days of the RMA# being issued by us.
          You
          are responsible for the cost of returning the product to us.

          <br>If you wish to return to us our product which we have correctly supplied to order you must let us
          know within 7 days of the date of delivery.
          If we agree to the return of such product we may charge you a handling or re-stocking fee of between $50.00 per
          product or 10% of the price of product
          returned plus any delivery costs. If we accept the return of product which was specifically produced to your
          specifications
          or has been damaged or altered by you, we will not credit you with the price paid for it. <br>
        </li>
        <li>
          <b>Claims</b> <br> If you have a dispute with us, you must notify our credit department in
          writing of your dispute
          within seven days of the receipt of our invoice. You may not set off against or deduct from the price of product
          you
          have ordered from us any money you claim we owe you. If you do not dispute an invoice within seven days of
          receipt
          of the invoice you will be deemed to have accepted the amounts payable in that invoice and waived your right to
          dispute
          any amount. All undisputed amounts must be paid by the Due Date (as defined in clause 5). You agree that you
          shall
          make no claim against us or Third-Party Supplier for any delay in delivery or any damaged the products delivered
          to
          you as a direct or indirect result of events beyond our control. <br>
        </li>
        <li>
          <b>
            Replacement or Money Back
          </b> <br> The products come with guarantees that cannot be excluded under the Commonwealth Competition
          and
          Consumer Act 2010 (Cth) ("ACL"). Nothing in these terms and conditions excludes, restricts or modifies any
          condition,
          warranty, right or remedy conferred on you by the ACL or any other applicable Law that cannot be excluded,
          restricted
          or modified by agreement. Subject to those rights that cannot be excluded under the ACL, our liability (and any
          Third-Party
          Supplier's liability) for a breach of a non-excludable condition or warranty is limited, at our option, to: <br>
          <ul style="list-style-type: lower-latin;">
            <li>
              in the case of goods, any one or more of the replacement of the goods or the supply of equivalent goods; the
              repair
              of the goods; the payment of the cost of replacing the goods or of acquiring equivalent goods; or the
              payment of
              the cost of having the goods repaired; or
            </li>
            <li>
              in the case of services, any one of the supplying of the services again; or the payment of the cost of
              having the
              services supplied again.
            </li>
          </ul>
          Subject to the foregoing, to the full extent of the law all other express or implied warranties or guarantees
          are excluded. Warranties do not apply if the product has received maltreatment, inattention or interference or
          the product has not been used in accordance with any performance ratings or care instructions. In no
          circumstances are we liable for loss of profit, loss of data, loss of business or contract or any special,
          indirect or consequential loss, even if you advise us of any special circumstances or such loss was reasonably
          foreseeable. <br>
        </li>
        <li>
          <b>Indemnity</b> You must defend, indemnify and hold harmless us and our Third Party Suppliers against
          any claims, demands, suits, damages, losses, liabilities, fines, penalties, judgments or costs or whatsoever
          nature (including reasonable legal fees) arising out of or connected with a breach of these terms and
          conditions; a violation of any applicable Law including but not limited to import or export laws; asserted of
          actual infringement of any intellectual property rights; personal injury, death or property damage; unlawful,
          unfair or deceptive trade practice and any other acts or omissions by you or your contractors.<br>
        </li>
        <li>
          <b>Conflict of Terms</b> <br> These terms and conditions override your terms and conditions,
          including any terms and conditions attached to any purchase order (even if issued after these terms and
          conditions). You acknowledge and agree any purchase order (and any terms and conditions attached to any purchase
          order) issued by you has no effect and is for administrative purposes only. To the extent of any discrepancy
          between these terms and conditions and any other (including your own) terms and conditions these terms and
          conditions prevail.
        </li>
        <li>
          <b> Minimum Purchase </b> <br> You acknowledge that we may impose a minimum quantity for
          individual purchases as a condition of sale. We may impose a processing fee for approved purchases below the
          minimum quantity.
        </li>
        <li>
          <b> Your Relationship with Us</b> <br> Nothing in these terms and conditions creates any
          relationship of employment,
          agency or partnership between you and us. To the maximum extent permitted by Law, you must not make any warranty
          or
          representation on behalf of us or a Third-Party Supplier. The benefit of these terms and conditions is held by
          us on
          our own behalf and on trust for our Third-Party Suppliers. <br>
        </li>
        <li>
          <b> Intellectual Property</b>
          <br> You agree to protect the intellectual property rights of the products and cooperate with us and
          our Third-Party Suppliers in their efforts to protect their intellectual property rights. You must notify us of
          any suspected or known breach or breaches of intellectual property rights as soon as is practicably possible
          after becoming aware of the breach or breaches. You must provide us or the Third-Party Supplier (as applicable)
          control of any proceedings and provide us or the Third-Party Supplier with all reasonable assistance in the
          defence of any claim the products infringe any third party intellectual property or other rights. These terms
          and conditions do not give you any intellectual property rights in the products. If we source, produce or
          manufacture any product samples or prototypes specifically for you, you do not acquire any intellectual property
          rights in such samples and prototypes. Your details and information that you provide us about yourself may be
          retained by us on our database and used by us or Third-Party Suppliers. You have no rights in that database. We
          may use such database in the conduct of our business, subject to privacy and other relevant Laws.

          <br>We are not liable for any infringement or unauthorised use of any intellectual property rights
          arising from these terms and conditions. If any dispute or claim is made in respect of any infringement or
          unauthorised use of intellectual property rights we may terminate these terms and conditions by notice to you
          and without liability to you or any other person.

          <br> In these terms and conditions, intellectual property rights include the full benefit of any rights
          in any copyright, trademark, registered design, patent, trade and business names, know-how, inventions,
          improvements, discoveries and confidential processes and includes without limitation artistic works, images,
          illustrations and photographs and any adaptation or concept relating to it. <br>
        </li>
        <li>
          <b> Confidential Information </b> <br> You must not directly or indirectly disclose
          Confidential Information to any
          other person. You must take all reasonable steps to secure and keep secure the Confidential Information coming
          into
          your possession. <br> For the purposes of this clause, "<b>Confidential Information</b>"
          includes, without limitation, our
          quotations and our and our Third-Party Suppliers' non-public information about current or future products and
          services,
          business plans, market data, financial; data, sales information and any other information that the party
          identifies
          as confidential, or which you should reasonably understand to be confidential. The obligations of
          confidentiality under
          this clause do not apply to information that is generally available to the public (other than by breach of these
          terms
          and conditions) or is required to be disclosed by any applicable Law. <br>
        </li>
        <li>
          <b> Governing Law</b> <br> These terms and conditions are governed by, and you agree to submit
          to, the laws applicable
          in the State of New South Wales, Australia and the Commonwealth Personal Property Securities Act 2009 (PPSA).
          You submit
          to the non-exclusive jurisdiction of the courts of New South Wales. <br>
        </li>
        <li>
          <b> Whole Agreement</b> <br>Subject to clause 4, these terms and conditions form the entire
          agreement on which we are willing to trade with you and all or any previous agreements or understandings we may
          have had with you are superseded by these terms and conditions. We may vary these terms and conditions at any
          time, either in writing or in or by way of a general notification on our website. All transactions after the
          date specified in such notice will be subject to the altered terms and conditions. If you continue to trade with
          us after the date such alterations become effective you will be deemed to have agreed to the altered terms and
          conditions. <br>
        </li>
        <li>
          <b>Your Obligations</b> <br> You acknowledge that: <br>
          <ul style="list-style-type: lower-latin;">
            <li>
              you are not an associate or related body corporate or related party or related entity of ours (as such terms
              are defined
              in the Corporations Act 2001); and
            </li>
            <li>
              the Consumer Credit Code does not apply to these terms and conditions. <br>It is your
              responsibility to ensure
              that the contact details we have about you including your address details are correct and up to date at all
              times.
              You must promptly notify us of any change in your contact details. If, at any time:
            </li>
            <li> you believe that you may not or may be unable to perform or comply with your obligations under
              these terms and conditions;</li>
            <li> you are unable to pay your accounts as they fall due for payment; </li>
            <li> you cease or threatens to cease to carry on business or are unable to pay your debts as they
              fall due.</li>
            <li> a cheque or bill of exchange received from you is dishonoured;</li>
            <li> you are or become insolvent or you have an administrator appointed; </li>
            <li> your account is overdue and is not settled within our trading terms; or </li>
            <li>there is a change or a change is proposed to your shareholding, shareholders or directors,</li>
          </ul>
          You agree that:<br>
          <ul style="list-style-type: lower-latin;">
            <li>
              you will immediately notify us that one or more of the above notifiable events has occurred and you will
              keep us
              notified on a monthly basis until such notifiable event no longer exists;
            </li>
            <li>
              we have no obligation and will cease to deliver to you any product you have purchased while a notifiable
              event exists;
            </li>
            <li> we may close your account with us, and/or terminate any agreement relating to the supply of
              product or services;</li>
            <li>we may request payment in advance for all products you have ordered from us; and</li>
            <li>
              we have no obligation to respond to any offer you make to purchase any of our product while a notifiable
              event exists.
            </li>
          </ul>
          For the purpose of these terms and conditions, you are insolvent if: <br>
          <ul style="list-style-type: lower-latin;">
            <li>
              a receiver or receiver and manager or an agent for a mortgagee in possession has been appointed over all of
              your
              assets and undertakings;
            </li>
            <li> you have passed an effective resolution for your voluntary winding-up or you have committed an
              act of bankruptcy;</li>
            <li>an order has been made by a Court of competent jurisdiction for you to be wound up;</li>
            <li> a compromise arrangement (excluding a voluntary administration) has been made legally binding on
              you and your creditors;</li>
            <li> you have presented a debtor’s petition and it has been accepted by the Registrar in Bankruptcy;
            </li>
            <li>
              you have entered into a composition, deed of assignment or deed of arrangement under Part X of the
              Bankruptcy Act
              (or equivalent) with your creditors; or
            </li>
            <li>a legally binding sequestration order has been made against your estate.</li>
          </ul>
        </li>
        <li>
          <b> PMSI</b>
          <br> You agree that these terms and conditions create a PMSI in the product (and their proceeds)
          supplied presently
          and in the future by us to you.
          <br> You agree to do all things necessary and execute all documents reasonably required
          by us to register the PMSI granted by you under these terms and conditions and to ensure that we acquire a
          perfected
          security interest in the product under the PPSA. <br> You will, upon demand, pay all of our expenses
          and legal costs
          (on a solicitor/agent/client basis) in relation to or in connection with the registration of the PMSI or any
          other
          security interest and all other costs associated with protection and enforcement of the PMSI or any other
          security
          interest created by these terms and conditions or by undertaking an audit under the provisions of the PPSA, or
          the
          repossession of the Product the subject of these terms and conditions or the exercise, enforcement or
          preservation
          of any right or interest under these terms and conditions or any contract that we have with you. <br>
          This PMSI does
          not lose its priority as a result of the renewal, refinance, consolidation or restructure of the subject matter
          of
          these terms and conditions and any purchase money obligations. <br> Until ownership of the product
          passes to you, you
          waive your rights under the following provisions of the PPSA, to the maximum extent that it is permitted by law,
          to:
          <br>
          <ul style="list-style-type: initial;">
            <li> receive a notice of intention to remove an accession (s.95); </li>
            <li> receive a notice that we have determined to enforce our security interest in accordance with
              land law (s118); </li>
            <li> receive a notice of enforcement action against liquid assets;</li>
            <li> receive a notice of disposal of the product by way of us purchasing the product from us (s129);
            </li>
            <li> receive a notice of disposal of the product (s130);</li>
            <li> receive a statement of account following disposal of the product (s132(2));</li>
            <li> receive a statement of account every 6 months where there has been no disposal of the product
              (s152(4));</li>
            <li> receive notice of retention of the product by us (s135(2));</li>
            <li> object to any proposal by us to either retain and dispose of the product (s137(3));</li>
            <li> redeem the product before we dispose of it (s142);</li>
            <li> reinstate the security agreement (s143); and</li>
            <li> receive any verification statement in relation to any registration event to which you are a
              party (s157(1) and 157(3)).</li>
          </ul>
          To the extent permitted by the PPSA, these terms and conditions exclude any provisions of the PPSA which may be
          excluded
          in our discretion and which would otherwise confer rights on you. <br> You further agree that where we
          have rights
          in addition to those under Part 4 of the PPSA, those rights shall continue to apply. Your right to possession of
          goods
          still owned by us under these terms and conditions shall cease if: <br>
          <ul style="list-style-type: lower-latin;">
            <li> you being an individual, commit an act of bankruptcy, or, </li>
            <li>
              you being a company, circumstances arise where a receiver, manager, administrator or controller becomes
              entitled
              to take possession of any of your assets, any proceedings are instituted for your winding up, or you enter
              into
              a Deed of Company Arrangement, or
            </li>
            <li>
              you cease or threaten to cease conducting business in the normal manner or apply for deregistration or
              receive a
              deregistration notice, or
            </li>
            <li> any cheque you provide to us is dishonoured for payment, or</li>
            <li> you fail to comply with any demand for payment issued by us, or</li>
            <li>
              you breach any of the terms and conditions contained herein and/or are in default of any other agreement
              between
              us and you.
            </li>
          </ul>
          You agree that we are entitled to enter any premises where the product supplied by us and still unpaid for is
          located and
          to repossess, remove and sell such product. You agree to indemnify and keep us indemnified in respect of any
          claims,
          actions and costs that may arise against us in relation to the removal, repossession and sale of the product
          pursuant
          to these terms and conditions including any claims brought by third parties. <br> You agree that
          repossession
          and retention of the product pursuant to the PPSA will only satisfy so much of the monies which may become
          payable
          to us by you, as is equivalent to our estimation of the market value of the product as it is at the date of
          repossession
          and the repossession and retention will immediately extinguish any rights for interest you have on the product
          value
          of product recovered. <br> Until ownership of the product passes, you must not give us a written demand
          or allow any
          other person to give us a written demand requiring us to register a financing change statement under the PPSA or
          enter
          into or allow any other person to enter into the personal property securities register a financing change
          statement
          under the PPSA. <br> You agree not to change your name or undertake any changes to any documents that
          we have registered,
          require to be registered or are capable of being registered without our prior written consent. <br>
        </li>
        <li>
          <b> Fitness for Purpose</b> <br>To the maximum extent permitted by law, you agree that you do
          not rely on our skill
          or judgement in relation to the suitability of any goods for a particular purpose. Any advice, recommendation,
          information
          or assistance provided by us is provided without any liability whatsoever <br>
        </li>
        <li>
          <b> Privacy and other Laws</b> <br>
          <ul style="list-style-type: lower-latin;">
            <li>Our Privacy Policy, available on our website or upon request to us, forms part of these terms and
              conditions. </li>
            <li>
              You agree to comply with all Laws, including all export and import control laws and the Privacy Act 1988
              (Cth) and
              the Australian Privacy Principles, the Spam Act 2003 (Cth) and the Do Not Call Register Act 2006 (Cth). You
              must
              obtain all consents and rights necessary for us and/or our Third-Party Suppliers to provide the products.
            </li>
            <li>
              In accordance with the Privacy Policy, you agree that we may use or disclose information to third parties
              (such as
              Third Party Suppliers) for the purpose of providing the product, providing information about product;
              sending information
              on our services; performing our administrative and marketing operations; complying with legislative and
              regulatory
              requirements or as otherwise permitted or authorised by Law; considering any other application you may make
              to
              us; managing our rights and obligations in relation to external payment systems, e.g. credit card schemes
              and debit
              payment schemes; conducting market research or customer satisfaction research; developing, establishing and
              administering
              arrangements (including rewards programs) with other organisations in relation to the promotion,
              administration
              and use of our products; and developing and identifying products and services that may interest you.
            </li>
            <li> Your use of Third Party Products may also be subject to the privacy policies of Third Party
              Suppliers.</li>
          </ul>

        </li>
        <li>
          <b> Charge</b> <br> You hereby charge all property, both equitable and legal, present or
          future of yours and the Company/Trustee Company/Trust/Sole Trader/Partnership (as applicable), in respect of any
          monies that may hereinafter be owing to us under this credit application and terms and conditions by you or
          otherwise. You hereby authorise us or our solicitors to execute any consent form as your attorney for the
          purpose of registering a mortgage or caveat over any real property owned by you and any of the Company/Trustee
          Company/ Trust/ Sole Trader/ Partnership (as applicable) at any time, or to register this charge over your
          assets and the Company/ Trustee Company/Trust/Sole Trader/Partnership (as applicable) with the Australian
          Securities and Investments Commission or any other applicable regulatory body. The costs and stamp duty payable
          on the mortgage or caveat are payable by you.<br>
        </li>
        <li>
          <b>Trust and Trustees</b> <br> Where you are a trustee: <br>
          <ul style="list-style-type: lower-latin;">
            <li> You agree to produce a stamped copy of the trust deed (with all amendments) if and when
              requested by us.</li>
            <li>
              You warrant that you have full power and authority to enter into this agreement on behalf of the trust and
              that the
              trust shall be bound by these terms and conditions both personally and as trustee, irrespective of whether
              or not
              you or the trust disclose to us that if you are a trustee at the time of entering into any credit agreement
              with
              us.
            </li>
          </ul>

        </li>
        <li>
          <b> General</b> <br> We may in our sole discretion assign, subcontract or sub licence any or
          all of our obligations
          under these terms and conditions from time to time. <br> Any time, indulgence, waiver or non-exercise
          by us of any
          of these terms and conditions shall not affect any of our rights under these terms and conditions nor shall it
          be deemed
          a waiver by us of any provision of these terms and conditions or subsequent breach of these terms and
          conditions. <br>
          If any term or condition is found to be invalid, illegal or otherwise unenforceable, it will be deemed modified
          to
          the extent necessary in the court's opinion to render it enforceable, and the rights and obligations of the
          parties
          will be construed and enforced accordingly, preserving, to the maximum extent possible, the intent of the
          parties.
          <br>
        </li>
        <li>
          <b>Interpretation</b>
          <br> In these terms and conditions unless otherwise indicated by the context
          <ul style="list-style-type: lower-roman;">
            <li> reference to a party to a document includes that party’s successors and permitted assigns; </li>
            <li> “including” and other similar words are not words of limitation; </li>
            <li>
              an agreement, deed, covenant, representation or warranty on the part of two or more persons binds them
              jointly and
              severally;
            </li>
            <li>
              general words following words describing a particular class or category are not restricted to that class or
              category;
            </li>
            <li>
              “Law” means any Commonwealth or Australian state legislation regulations and the general law (all as amended
              or replaced
              from time to time) and includes in particular the Commonwealth Competition and Consumer Act 2010 (Cth) the
              Personal
              Property Securities Act 2009 (Cth);
            </li>
            <li>
              “PPSA” means Personal Property Securities Act 2009 (Cth); “Purchase Monies Securities Interest” or “PMSI”
              has the
              meaning given in section 14 of the PPSA;
            </li>
            <li>“Corporations Act 2001” means the Corporation Act 2001 (Cth); </li>
            <li> "Privacy Statement" means our privacy statement attached as Schedule 1; </li>
            <li>
              “Third Party Product” means software, products and services that are provided by third parties or
              interoperate with
              our product and/or that may be identified as a third party product or services; and
            </li>
            <li>“Third Party Suppliers” means the suppliers or vendors of the Third Party Products.</li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="subbanner">
      SCHEDULE 1 -PRIVACY STATEMENT
    </div>
    <div class="terms-description">
      DICKER DATA LTD trading as Dicker Data (“we” or “us” or “our”) respects your privacy and we are committed to the
      protection
      of personal information. We follow the National Privacy Principles in the Privacy Act 1988 (Cth). <br> The
      purpose of
      this Privacy Statement is to let you know how we collect, use and disclose personal information. <br>
      <br>
      <b>Collection</b> <br> We collect personal information so that we can provide you with our
      services and products and to
      manage our activities. We only collect personal information that is relevant and where necessary. <br> The
      type of personal
      information we collect will depend upon the reason for its collection. If you are interested in our products, the
      type
      of information we collect will include financial details and credit and trade references. <br> We collect
      personal information
      about you in a number of ways including: <br>
      <ul>
        <li>
          directly from you, such as when you:
          <ul class="dashstyle">
            <li>&nbsp;contact us about our services or products;</li>
            <li>&nbsp;fill in an account application form; </li>
            <li>&nbsp;subscribe to our newsletters or mailing lists; </li>
            <li>&nbsp;place an order for our products; </li>
            <li>
              &nbsp;enter your personal details on our website (for example during registration or application for
              services, products
              or employment);
            </li>
            <li> &nbsp;provide information by phone or in documents sent by fax or email; </li>
            <li> &nbsp;enter promotions, competitions or giveaways; or</li>
            <li> &nbsp;make a payment to us;</li>
          </ul>
        </li>
        <li> from organisations which we might be working together with when providing you with services or
          products;</li>
        <li> from your representatives including executors and attorneys;</li>
        <li> from publicly available sources of information;</li>
        <li>
          from credit-reporting and fraud-checking agencies and credit providers for credit related purposes such as
          credit worthiness,
          credit rating, credit provision and financing;
        </li>
        <li> from our own records of your dealings with us; or</li>
        <li> when legally required to do so.</li>
      </ul>
      Where reasonable and practicable, we collect personal information directly from you rather than a third party. When
      we collect
      personal information, we collect it in a way that is lawful, fair and not intrusive. <br> We do not collect
      sensitive
      information about you without your consent. <br><br>
      <b>Use &amp; Disclosure</b> <br> Personal information which we have collected for a particular
      purpose will not be used for
      any other purpose unless that purpose is related to the main purpose for which we collected the information and it
      is reasonable
      to expect us to use or disclose the information for that other purpose. <br> Personal information which we
      collect may
      be used by us: <br>
      <ul>
        <li> to identify you; </li>
        <li> in providing services or products to you and the administration and management of those services and
          products; </li>
        <li> to provide you with information about our services and products; </li>
        <li> to develop and improve our services to you; </li>
        <li> in undertaking risk assessment and management; or </li>
        <li>
          in gathering data and disclosing data to third parties such as:
          <ul class="dashstyle">
            <li> &nbsp; insurance brokers and insurers; </li>
            <li> &nbsp; credit reporting agencies; </li>
            <li> &nbsp; financial institutions including our own bankers; </li>
            <li> &nbsp; our professional advisors, including our accountants, auditors and lawyers; </li>
            <li> &nbsp; service providers; and </li>
            <li>
              &nbsp; ndustry groups having a legitimate reason to receive such information, as necessary from time to time
              for
              our organisation’s functions.
            </li>
          </ul>
        </li>
      </ul>
      If you provide us with personally identifiable information, you may receive from time to time, telephone calls,
      emails or letters containing information about us. You agree to receiving emails and letters from us including
      information not only on the areas of interest you have indicated but all types of news and information on our
      services and products. If you do not want to receive them, please contact us. You may be asked to indicate your
      preference to receiving promotional material, when submitting information to us.<br>
      We may employ other companies or individuals to assist us in providing our services, or to provide certain services
      such as analysing customer lists, providing marketing assistance or consulting services. These third parties may
      have access to information needed to perform their function but cannot use that information for other purposes.<br
      >
      We do not provide any personal information to any third parties other than where required by law or as set out in
      this Privacy Statement.<br>
      We will not sell, trade or rent your personal information to others. We may provide aggregate statistics on our
      customers and users of our website to third parties such as advertisers, but these statistics will include no
      personally identifying information.<br>
      We co-operate with law enforcement agencies as required by law. We will also use or disclose personal information if
      we reasonably believe that it is necessary to lessen or prevent a serious or imminent threat to the life or health
      of a person.<br>

      <br>
      <b>Security</b> <br> All reasonable steps are taken to ensure that all information is treated
      confidentially, kept secure and protected against unauthorised use, modification or disclosure and is maintained
      only for the purpose for which it is intended. Your email address will not be distributed to any third party. <br
      > We use secure data communications technology.
      <br> You have the rights given by the Privacy Act 1988 as amended. <br>
      <br>
      <b>Anonymity</b> <br> Where possible, we give you the opportunity to deal with us anonymously. We
      may not however be able to provide you with our full range of services and products if you do not provide us with
      personal information. <br>
      <br> <b>Access</b> <br> All reasonable steps are taken to correct the information we hold
      where that information is not accurate, up-to-date and complete. <br> You have the right to access your
      personal information to ensure that it is accurate, relevant, up to date and complete. If you believe that any of
      your personal information is incorrect, please let us know. There is no fee for requesting access to your
      information, however, we may charge you the reasonable cost of processing your request.
      <br> We may decline access to your personal information in special circumstances, such as where allowing
      you access could put you or another person at risk of harm, infringes on the privacy of another person or if we
      believe that your request for access is unlawful, frivolous or vexatious. <br>

      <br><b> Intellectual Property</b> <br>Intellectual property in all material sent to you
      belongs to, is licensed to or is authorised for use by us. We permit you to print or download extracts from this
      material for your personal use only. None of this material may be used for any commercial or public use, stored in
      or transmitted to any other website or distributed in any other form without our prior permission. <br>
      <br><b>Cookies</b> <br> Cookies that are used in any part of our website will not be
      utilised for collecting personally identifiable information and will only be used for internal management purposes
      <br>
      <br> <b>Links</b><br> Our website may from time to time contain links to the websites of
      other organisations which may be of interest to you. If you access linked sites, you do so at your own risk. We do
      not operate or control these third-party sites and we are not responsible for their contents, operation, privacy,
      accuracy or security policies. This Privacy Statement does not cover any linked sites.<br>
      <br><b> Contact Us</b>
      <br> If any personal information you submit changes, please update that information by contacting us.
      <br> We may from time to time make changes to this Privacy Statement. The latest version of our Privacy
      Statement is available on our website. You can also contact us to obtain a copy our Privacy Statement. <br>
      Requests for information about our Privacy Statement are welcomed. For further information on our Privacy Statement
      please contact: <br><br>
      <div class="register-logo">
          <img class="logoImg" src="/images/new_ui/terms-logo.jpg" alt="register-logo">
      </div>
      <div class="contactInfo">
        <pre class="contactText">
            <b>Privacy Officer Dicker Data Limited </b>
            ABN: 95 000 969 362  |  230 Captain Cook Drive, Kurnell NSW, 2231 
            Ph: +612 9589 8400 |  Email: accounts@dickerdata.com.au  |  www.dickerdata.com.au
        </pre>
      </div>

      <br>
    </div>
  </div>

  <div mat-dialog-actions style="display: block;">
    <div class="row" style="margin: auto;">
        <button mat-button cdkFocusInitial class="button button-red button-large" style="margin: 0 auto;" (click)="saveTermAndCondition()">Confirm</button>
    </div>
    
    <div class="row" style="margin: auto;">
        <a href="javascript:void(0)" class="declineLink" (click)="declineTermAndCondition()">Decline</a>
    </div>
  </div>
</div>